<template>
  <v-container
    id="melhoresprodutores-form"
    fluid
    tag="section"
    class="px-3 pt-0 color"
    style="margin-top: 1rem"
  >
    <v-responsive>
      <div>
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <dashboard-filtro-produtores
              :primeiro="enablePrimeiroDia"
              :ultimo="enableUltimoDia"
              :empresas="enableEmpresa"
              :url="link"
              :produtores="enableProdutores"
              :linhas="enableLinha"
            />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="3"
              >
                <dashoard-card-view
                  :exibir-texto-titulo="true"
                  :code-information="'347'"
                  :text="'Como estão meus produtores?'"
                  :texto-information="textoProdutoresPositivados"
                  :style-object="styleObject"
                  :componente-grafico="true"
                  :grafico-id="'myChartCobProdutores'"
                  :dados-grafico="chartCoberturaProdutores"
                  :titulo-id="'titulo5'"
                  :title="'Cobertura de produtores'"
                  :exibir-titulo-grafico="exibirTituloGrafico"
                  :legenda-grafico="legendaCoberturaProdutores"
                  :exibir-legenda="true"
                  :padding="dynamicPaddingBloco"
                  :router-link-positivados="'/produtores/detalhe-produtores-positivados'"
                  :router-link-ativos="'/produtores/detalhe-produtores-ativos'"
                  :text-positivados="'Produtores Positivados'"
                  :text-ativos="'Total Produtores Ativos '"
                  :total-positivados="produtoresPositivados"
                  :total-ativos="produtoresAtivos"
                  :exibir-informacao="true"
                  :exibir-dados-clientes="true"
                  :loading="loadingCoberturaProdutores"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="11"
                lg="6"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Qual a distribuição geográfica dos meus produtores?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          class="text-right"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              id="iconInformation"
                              class="text-right"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('348')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="textoDistribuicaoGeografica">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <dashboard-produtores-maps />
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="3"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        E a participação de novos produtores?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          class="text-right"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              id="iconInformation"
                              class="text-right"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('351')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="textoNovosProdutores">
                    <div
                      v-if="loading"
                      :style="styleObject"
                      class="text-center"
                    >
                      <v-icon
                        light
                        class="custom-loader"
                        :style="styleObject"
                      >
                        mdi-cached
                      </v-icon>
                      Carregando dados...
                    </div>
                    <div
                      v-else-if="error"
                      class="alert alert-danger"
                    >
                      {{ error }}
                    </div>
                    <div v-else>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <v-row>
                            <v-col
                              cols="12"
                              sm="10"
                              md="10"
                              lg="10"
                            >
                              <div
                                id="textoClientesNovos"
                                class="text-center"
                                :style="styleCurrency"
                              >
                                {{ produtoresNovos }} Produtores Novos
                              </div>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="2"
                              md="2"
                              lg="2"
                            >
                              <router-link
                                to="/produtores/detalhe-entregaleite-novos-produtores"
                                :style="styleObject"
                              >
                                <v-icon
                                  id="linkNovosProdutores"
                                >
                                  mdi-arrow-top-right-bold-box-outline
                                </v-icon><br>
                              </router-link>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row><br><br><br><br><br>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          lg="6"
                        >
                          <div
                            id="iconCombinado"
                            class="text-center"
                          >
                            <v-icon
                              id="handCliente"
                              :style="styleCurrency"
                            >
                              mdi-hand-extended-outline
                            </v-icon>
                            <v-icon
                              id="currencyCliente"
                              class="text-center"
                              :style="styleCurrency"
                            >
                              mdi-currency-usd
                            </v-icon>
                          </div>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          lg="6"
                        >
                          <v-row
                            id="textoParticipacao"
                          >
                            Part. das entregas de leite
                          </v-row>
                          <v-row
                            id="percentualParticipacao"
                          >
                            {{ participacaoProdutoresNovos }}
                          </v-row>
                        </v-col>
                      </v-row><br><br><br>
                    </div>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <div v-if="!text">
                          <div
                            v-if="loadingGrafico"
                            id="carregaDados"
                            class="text-center"
                            :style="styleObject"
                          >
                            <v-icon
                              light
                              class="custom-loader"
                              :style="styleObject"
                            >
                              mdi-cached
                            </v-icon>
                            Carregando Dados...
                          </div>
                          <div
                            v-else-if="errorGrafico"
                            class="alert alert-danger"
                          >
                            {{ errorGrafico }}
                          </div>
                          <canvas
                            id="myChart34"
                            width="180"
                            height="130"
                          />
                          <div
                            v-if="exibirLegenda"
                            id="legendaDistribuicaoCliente"
                            class="text-center"
                          >
                            <v-row
                              align="center"
                              class="ma-0"
                              no-gutters
                            >
                              <v-col
                                md="6"
                                offset-md="3"
                              >
                                <v-row>
                                  <div
                                    v-for="status in statusDistruibuicao"
                                    :key="status.statusExibicao"
                                  >
                                    <v-avatar
                                      class="mr-1"
                                      :color="status.corExibicao"
                                      size="12"
                                    />
                                    <span class="mr-3 font-weight-light">{{ status.statusExibicao }}</span>
                                  </div>
                                </v-row>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                        <div
                          v-else
                        >
                          {{ text }}
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-col>
            </v-row><br>
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col
          cols="12"
          :sm="dynamicSm"
          :md="dynamicMd"
          :lg="dynamicLg"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Quais são os 20 produtores que mais entregaram leite no ano?
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    class="text-right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        id="iconInformation"
                        class="text-right"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('350')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <produtores-exibicao-melhores />
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          :sm="dynamicSm"
          :md="dynamicMd2"
          :lg="dynamicLg2"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Entradas de Leite
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    class="text-right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        id="iconInformation"
                        class="text-right"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('359')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <linhas-exibicao-entregas />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Compra de leite Spot
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    class="text-right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        id="iconInformation"
                        class="text-right"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('367')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <compra-leite-spot-exibicao />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="4"
          class="mb-4"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Comparativo de produtores
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    class="text-right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        id="iconInformation"
                        class="text-right"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('364')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <dashboard-comparativo-cad-produtores />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="4"
          class="mb-4"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Volume de leite a cada mês
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    class="text-right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        id="iconInformation"
                        class="text-right"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('365')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <dashboard-comparativo-volume-leite />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="4"
          class="mb-4"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Preço médio do leite a cada mês
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    class="text-right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        id="iconInformation"
                        class="text-right"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('366')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <dashboard-comparativo-preco-medio-leite />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Leite coletado
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    class="text-right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        id="iconInformation"
                        class="text-right"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('368')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <dashboard-leite-coletado />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Quilometragem percorrida
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    class="text-right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        id="iconInformation"
                        class="text-right"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('369')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <dashboard-km-percorrido />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-card
            id="cardDashbord"
            class="mx-auto"
            outlined
          >
            <div class="card-header-dashbord">
              <v-row>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  class="d-flex flex-wrap"
                >
                  Aproveitamento - L/Km
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-end"
                >
                  <v-tooltip
                    top
                    class="text-right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        id="iconInformation"
                        class="text-right"
                        v-bind="attrs"
                        v-on="on"
                        @mouseover="enableTexto('370')"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div
                      v-if="!carregandoTooltip"
                      v-html="textoOrientacao"
                    />
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <dashboard-coleta-por-km />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </v-responsive>
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import Entregaleite from '../../../../services/entregaleite'
  import Chart from 'chart.js'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardProdutores',
    emits: ['setCoberturaProdutor', 'setClienteLocalizacao', 'setFaturamentoClienteNovos', 'getOrientacao', 'set_comparativo_cadprodutores', 'atualizarTexto'],
    components: {
      DashboardFiltroProdutores: () => import('../../components/core/FiltroProdutores'),
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardProdutoresMaps: () => import('../../maps/Produtores/DashboardProdutoresMaps'),
      ProdutoresExibicaoMelhores: () => import('../../components/produtores/ProdutoresExibicaoMelhores'),
      LinhasExibicaoEntregas: () => import('../../components/produtores/LinhasExibiçãoEntregas'),
      DashoardCardView: () => import('../../components/core/CardView.vue'),
      DashboardComparativoCadProdutores: () => import('../../graficos/Produtores/ComparativoCadProdutores'),
      DashboardComparativoVolumeLeite: () => import('../../graficos/Produtores/ComparativoVolumeLeite.vue'),
      DashboardComparativoPrecoMedioLeite: () => import('../../graficos/Produtores/ComparativoPrecoMedioLeite.vue'),
      CompraLeiteSpotExibicao: () => import('../../components/produtores/CompraLeiteSpotExibicao.vue'),
      DashboardLeiteColetado: () => import('../../graficos/Produtores/LeiteColetado'),
      DashboardKmPercorrido: () => import('../../graficos/Produtores/KmPercorridoColeta'),
      DashboardColetaPorKm: () => import('../../graficos/Produtores/ColetaPorKm'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleProdutor: {
        color: '#ed934f',
      },
      styleCurrency: {
        color: '#4CAF50',
      },
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableLinha: true,
      link: window.location.href,
      enableProdutores: true,
      paginaEnable: false,
      permissaoProdutores: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      produtorSelect: [],
      linhaSelect: [],
      produtoresSelect: 0,
      produtoresPositivados: 0,
      produtoresTotalAtivos: 0,
      produtoresAtivos: 0,
      produtoresNovos: 0,
      participacaoProdutoresNovos: 0,
      loading: false,
      loadingCard: false,
      loading1: false,
      error: null,
      error1: null,
      loadingGrafico: false,
      text: null,
      montaGrafico: true,
      montaGraficoCobertura: true,
      errorGrafico: null,
      exibirLegenda: false,
      codigo: 0,
      orientacao: [],
      codigoIds: ['347', '348', '349', '350', '351', '359', '360', '364', '365', '366', '367', '368', '369', '370'],
      textoProdutoresPositivados: '',
      textoDistribuicaoProdutores: '',
      textoProdutoresNovos: '',
      textoProdutoresMelhores: '',
      textoMelhoresLinhasLeite: '',
      textoComparativoCadProdutores: '',
      textoComparativoVolumeLeite: '',
      textoComparativoPrecoMedio: '',
      textoComraSpot: '',
      textoGraficoLeiteColetado: '',
      textoGraficoKmPercorrido: '',
      textoGraficoAproveitamento: '',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart: {},
      chartCoberturaProdutores: {},
      exibirTituloGrafico: false,
      statusDistruibuicao: [
        { statusExibicao: 'Produtores novos', corExibicao: '#4CAF50' },
        { statusExibicao: 'Produtores', corExibicao: '#E8F5E9' },
      ],
      legendaCoberturaProdutores: [
        { status: 'Positivados', valor: 0, cor: '#2863af' },
        { status: 'Sem Positivação', valor: 0, cor: '#ed934f' },
      ],
      paddingResize: 'padding-right: 4rem !important',
      larguraTela: false,
      dynamicPaddingBloco: '',
      dynamicPaddingProdutores1: '',
      dynamicPaddingProdutores2: '',
      dynamicPaddingProdutores3: '',
      dynamicPaddingProdutores4: '',
      dynamicPaddingProdutores5: '',
      dynamicPaddingProdutores6: '',
      dynamicSm: '7',
      dynamicMd: '7',
      dynamicLg: '7',
      dynamicMd2: '5',
      dynamicLg2: '5',
      loadingCoberturaProdutores: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,

    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      eventEmit.$emit('atualizar_texto', 'Produtores')

      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)

      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, produtor, linha) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.produtorSelect = produtor
        this.linhaSelect = linha

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaSelect', JSON.stringify(this.select || []))
        localStorage.setItem('produtorSelect', JSON.stringify(this.produtorSelect || []))
        localStorage.setItem('linhaSelect', JSON.stringify(this.linhaSelect || []))

        this.updateDate()
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      updateDate () {
        this.produtoresPositivados = 0
        this.totalLeite = 0
        this.produtoresAtivos = 0
        this.produtoresNovos = 0
        this.participacaoProdutoresNovos = 0

        this.loadingCoberturaProdutores = true

        this.showDadosprodutoresSelect()
        this.showDadosNovosProdutores()
        this.MontarGrafico()

        eventEmit.$emit('set-localizacao-produtor', this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, this.linhaSelect)
        eventEmit.$emit('set_faturamento_novos_produtores', this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, this.linhaSelect)
        eventEmit.$emit('set_produtores_mais_entregaramleite', this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, this.linhaSelect)
        eventEmit.$emit('set_entregas-porlinha', this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, this.linhaSelect)
        eventEmit.$emit('set_comparativo_cadprodutores', this.primeiroDia, this.ultimoDia, this.select, this.linhaSelect)
        eventEmit.$emit('set_compra_spot', this.primeiroDia, this.ultimoDia, this.select, this.linhaSelect)
        eventEmit.$emit('set_leite_coletado', this.primeiroDia, this.ultimoDia, this.select, this.linhaSelect)
      },

      async showDadosprodutoresSelect () {
        this.loadingCard = true

        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaSelect', JSON.stringify(this.select || []))
        localStorage.setItem('produtorSelect', JSON.stringify(this.produtorSelect || []))
        localStorage.setItem('linhaSelect', JSON.stringify(this.linhaSelect || []))

        if (this.chartCoberturaProdutores.data) {
          this.chartCoberturaProdutores.destroy()
        }

        await Entregaleite.showprodutoresPositivados(this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, localStorage.tokencontrato, this.linhaSelect).then(resposta => {
          if (resposta.data.status) {
            this.produtoresPositivados = resposta.data.produtoresPositivados
            this.totalLeite = resposta.data.totalLeite
            this.produtoresAtivos = resposta.data.produtoresAtivos

            this.montarGraficoCobertura(this.produtoresPositivados, this.produtoresAtivos)
            this.showDelhamentoProdutoresPositivados()
          }
        }).catch(e => {
          if (e.status === 412) {
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingCard = false
        })
      },

      async showDadosNovosProdutores () {
        this.loading1 = true
        await Entregaleite.showProdutoresNovos(this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, localStorage.tokencontrato, this.linhaSelect).then(resposta => {
          if (resposta.data.status) {
            this.produtoresNovos = resposta.data.produtoresNovos
          }
        }).catch(e => {
          if (e.status === 412) {
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.message === 'Network Error') {
            this.error1 = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading1 = false
        })
      },

      async MontarGrafico () {
        this.loadingGrafico = true
        this.exibirLegenda = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Entregaleite.showComparativoProdutores(this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, localStorage.tokencontrato, this.linhaSelect, this.redeSelect).then(resposta => {
          if (resposta.data.status) {
            this.participacaoProdutoresNovos = (resposta.data.participacao).toFixed(2).replace('.', ',') + '%'

            const ctx = document.getElementById('myChart34').getContext('2d')
            this.myChart = new Chart(ctx, {
              type: 'horizontalBar',
              data: {
                labels: resposta.data.datas,
                datasets: [
                  {
                    label: 'Entregas de leite de novos Produtores',
                    data: resposta.data.entregaLeiteNovosProdutores,
                    backgroundColor: '#4CAF50',
                    order: 1,
                  },
                  {
                    label: 'Entregas de leite produtores',
                    data: resposta.data.entregaLeiteProdutores,
                    backgroundColor: '#E8F5E9',
                    order: 2,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      if (tooltipItem.xLabel > 0) {
                        var type = data.datasets[tooltipItem.datasetIndex].label
                        var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                        return type + ': ' + valor
                      } else {
                        return null
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há dados no período selecionado') {
            this.text = resposta.data.mg

            this.errorGrafico = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há dados no período selecionado') {
            this.text = resposta.data.mg

            this.errorGrafico = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.errorGrafico = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingGrafico = false
          this.exibirLegenda = true
        })
      },

      montarGraficoCobertura (produtoresPositivados, produtoresTotalAtivos) {
        try {
          this.loading = true
          const label = ['Positivados', 'Sem Positivação']
          this.montaGraficoCobertura = true

          if (this.montaGraficoCobertura) {
            this.montaGraficoCobertura = false
            const porcentagemProdutoresPositivados = produtoresPositivados > 0 && produtoresTotalAtivos > 0 ? (produtoresPositivados / produtoresTotalAtivos) * 100 : 0
            const restantePorcentagem = 100 - porcentagemProdutoresPositivados

            this.porcentagemProdutoresPositivados = porcentagemProdutoresPositivados.toFixed(2).toString().replace('.', ',') + '%'

            this.legendaCoberturaProdutores[0].valor = porcentagemProdutoresPositivados.toFixed(2).toString().replace('.', ',') + '%'
            this.legendaCoberturaProdutores[1].valor = restantePorcentagem.toFixed(2).toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChartCobProdutores').getContext('2d')

            this.chartCoberturaProdutores = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Positivação', 'Sem Positivação'],
                datasets: [
                  {
                    label: 'Porcentagem',
                    data: [porcentagemProdutoresPositivados, restantePorcentagem],
                    backgroundColor: [
                      '#2863af',
                      '#ed934f',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                cutoutPercentage: 70,
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.index === 0) {
                        return 'Total: ' + produtoresPositivados
                      } else if (tooltipItem.index === 1) {
                        return 'Total: ' + (produtoresTotalAtivos - produtoresPositivados)
                      }
                    },
                    title: (tooltipItem) => {
                      return label[tooltipItem[0].index]
                    },
                  },
                },
              },
            })

            this.loading = false
            this.exibirLegenda = true
            this.exibirTituloGrafico = true
          } else {
            if (this.chartCoberturaProdutores.data) {
              this.chartCoberturaProdutores.destroy()
            }

            this.porcentagemprodutoresPositivados = null

            const porcentagemProdutoresPositivado = this.produtoresPositivados > 0 && this.produtoresTotalAtivos > 0 ? (this.produtoresPositivados / this.produtoresTotalAtivos) * 100 : 0
            const restantePorcentagem = 100 - porcentagemProdutoresPositivado

            this.porcentagemProdutoresPositivados = porcentagemProdutoresPositivado.toFixed(2).toString().replace('.', ',') + '%'

            this.legendaCoberturaProdutores[0].valor = porcentagemProdutoresPositivado.toFixed(2).toString().replace('.', ',') + '%'
            this.legendaCoberturaProdutores[1].valor = restantePorcentagem.toFixed(2).toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChartCobProdutores').getContext('2d')
            this.chartCoberturaProdutores = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Positivação', 'Sem Positivação'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [porcentagemProdutoresPositivado, restantePorcentagem],
                    backgroundColor: [
                      '#2863af',
                      '#ed934f',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                cutoutPercentage: 70,
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.index === 0) {
                        return 'Total: ' + this.produtoresPositivados
                      } else if (tooltipItem.index === 1) {
                        return 'Total: ' + (this.produtoresTotalAtivos - this.produtoresPositivados)
                      }
                    },
                    title: (tooltipItem) => {
                      return label[tooltipItem[0].index]
                    },
                  },
                },
              },
            })

            this.exibirLegenda = true
          }
        } catch (error) {
          console.error('Error in montarGraficoCobertura:', error)
        } finally {
          this.loadingCoberturaProdutores = false
        }
      },

      async showDelhamentoProdutoresPositivados () {
        this.loading = true

        await Entregaleite.showDelhamentoProdutoresPositivados(this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, localStorage.tokencontrato, this.linhaSelect).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.produtoresPositivados.map((item) => {
              var listaDetalhamento = ({
                cliente: item.nome,
                linhaleite: item.linhaleite,
                quantidadeleite: parseFloat(item.qtdleite).toLocaleString('pt-BR'),
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBloco = 'padding-right: 10rem !important'

          this.dynamicPaddingProdutores1 = 'padding-right: 33rem !important'

          this.dynamicPaddingProdutores2 = 'padding-right: 8rem !important'

          this.dynamicPaddingProdutores3 = 'padding-right: 40rem !important'

          this.dynamicPaddingProdutores4 = 'padding-right: 16.5rem !important'

          this.dynamicPaddingProdutores5 = 'padding-right: 6.1rem !important'

          this.dynamicPaddingProdutores6 = 'padding-right: 94rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBloco = 'padding-right: 4rem !important'

          this.dynamicPaddingProdutores1 = 'padding-right: 18rem !important'

          this.dynamicPaddingProdutores2 = 'padding-right: 1rem !important'

          this.dynamicPaddingProdutores3 = 'padding-right: 21rem !important'

          this.dynamicPaddingProdutores4 = 'padding-right: 4.1rem !important'

          this.dynamicPaddingProdutores5 = 'padding-right: 12rem !important'

          this.dynamicPaddingProdutores6 = 'padding-right: 63rem !important;'
        } else if (window.innerWidth > 380 && window.innerWidth <= 600) {
          this.dynamicPaddingBloco = 'padding-right: 7rem !important'

          this.dynamicPaddingProdutores1 = 'padding-right: 7rem !important'

          this.dynamicPaddingProdutores2 = 'padding-right: 7rem !important'

          this.dynamicPaddingProdutores3 = 'padding-right: 7rem !important'

          this.dynamicPaddingProdutores4 = 'padding-right: 5.8rem !important'

          this.dynamicPaddingProdutores5 = 'padding-right: 5.7rem !important'

          this.dynamicPaddingProdutores6 = 'padding-right: 6.9rem !important'
        } else if (window.innerWidth > 1000 && window.innerWidth <= 1380) {
          this.dynamicPaddingBloco = 'padding-right: 2rem !important'

          this.dynamicPaddingProdutores1 = 'padding-right: 14rem !important'

          this.dynamicPaddingProdutores2 = 'padding-right: 0rem !important'

          this.dynamicPaddingProdutores3 = 'padding-right: 18rem !important'

          this.dynamicPaddingProdutores4 = 'padding-right: 2.6rem !important'

          this.dynamicPaddingProdutores5 = 'padding-right: 10rem !important'

          this.dynamicPaddingProdutores6 = 'padding-right: 56.2rem !important;'
        } else if (window.innerWidth > 600 && window.innerWidth <= 1000) {
          this.dynamicSm = '12'
          this.dynamicMd = '12'
          this.dynamicLg = '12'
          this.dynamicMd2 = '12'
          this.dynamicLg2 = '12'

          this.dynamicPaddingBloco = 'padding-right: 25rem !important'

          this.dynamicPaddingProdutores1 = 'padding-right: 25rem !important'

          this.dynamicPaddingProdutores2 = 'padding-right: 25rem !important'

          this.dynamicPaddingProdutores3 = 'padding-right: 25rem !important'

          this.dynamicPaddingProdutores4 = 'padding-right: 25rem !important'

          this.dynamicPaddingProdutores5 = 'padding-right: 23.8rem !important'

          this.dynamicPaddingProdutores6 = 'padding-right: 25rem !important;'
        } else {
          this.dynamicPaddingBloco = 'padding-right: 5rem !important'

          this.dynamicPaddingProdutores1 = 'padding-right: 5rem !important'

          this.dynamicPaddingProdutores2 = 'padding-right: 5rem !important'

          this.dynamicPaddingProdutores3 = 'padding-right: 5rem !important'

          this.dynamicPaddingProdutores4 = 'padding-right: 5rem !important'

          this.dynamicPaddingProdutores5 = 'padding-right: 5rem !important'

          this.dynamicPaddingProdutores6 = 'padding-right: 5rem !important'
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    #iconInformationNovosProdutoresParcipantes {
      margin: auto;
    }

    #iconInformationNovosProdutores {
      margin: -7rem 0 0 0;
    }

    #linkNovosProdutores {
      margin: -7.3rem 0 0 25rem;
    }

    #textoClientesNovos {
      font-size: 22px;
      font-weight: bold;
      margin: -2rem 0 0 -11rem;
    }

    #iconCombinado {
      margin: -8rem 0 0 -20rem;
    }

    #textoParticipacao {
      margin: -11.5rem 0 0 8rem;
      font-size: 14px;
      font-weight: bold;
    }

    #percentualParticipacao {
      margin: 0 0 0 10rem;
      color: #4CAF50;
      font-size: 22px;
      font-weight: bold;
    }

    #filtrosOpcoesClientesRFV {
      color: black;
      margin: 0 0 0 -25rem;
    }

    #filtrosOpcoesClientesExtrato {
      color: black;
      margin: -6.6rem 0 0 -3rem;
    }

    #filtrosOpcoesClientesABC {
      color: black;
      margin: -8.2rem 0 0 21rem;
    }

    #idProdutoresParticipantes {
      margin: -3rem 0 0 0;
    }

    #myChart34 {
      margin: -12rem 0 0 0;
    }

    #legendaDistribuicaoCliente {
      font-size: 10px;
      margin: 1.5rem 0 1rem 10rem
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #iconInformationNovosProdutoresParcipantes {
      margin: auto;
    }

    #iconInformationNovosProdutores {
      margin: -7rem 0 0 0;
    }

    #linkNovosProdutores {
      margin: -7.3rem 0 0 25rem;
    }

    #textoClientesNovos {
      font-size: 22px;
      font-weight: bold;
      margin: 0 0 0 -11rem;
    }

    #iconCombinado {
      margin: -8rem 0 0 -20rem;
    }

    #textoParticipacao {
      margin: -11rem 0 0 12rem;
      font-size: 14px;
      font-weight: bold;
    }

    #percentualParticipacao {
      margin: 0 0 0 14rem;
      color: #4CAF50;
      font-size: 22px;
      font-weight: bold;
    }

    #filtrosOpcoesClientesRFV {
      color: black;
      margin: 2rem 0 0 -6rem;
    }

    #filtrosOpcoesClientesExtrato {
      color: black;
      margin: 2rem 0 0 1rem;
    }

    #filtrosOpcoesClientesABC {
      color: black;
      margin: 2rem 0 0 7rem;
    }

    #idProdutoresParticipantes {
      margin: -1rem 0 0 0;
    }

    #myChart34 {
      margin: -12rem 0 0 0;
    }

    #legendaDistribuicaoCliente {
      font-size: 10px;
      margin: 1rem 0 0 0;
    }
    #melhoresEntregas {
      padding-right: 1rem;
    }

  }
</style>

<style lang="sass">
  #bloco1
    // margin-left: -5rem

  #opcoesClientes
    margin: -2rem 0 0 0

  #produtoresParticipantes
    font-size: 14px
    font-weight: bold

  #novosProdutores
    margin-left: -2rem

  #iconInformationNovosProdutores
    margin-left: -2rem

  #distribuicaoProdutores
    font-size: 14px
    font-weight: bold

  #participacaoNovosProdutores
    font-size: 14px
    font-weight: bold

  #produtoresPositivados
    font-size: 22px
    font-weight: bold

  #textoClientesNovos
    font-size: 22px
    font-weight: bold

  #linkNovosProdutores
    margin: 0.5rem 0 0 0

  #currencyCliente
    margin: -5.5rem 0 0 -2.5rem
    font-size: 26px
    font-weight: bold

  #handCliente
    margin: -2rem 0 0 0
    font-size: 42px
    font-weight: bold

  #textoParticipacao
    margin: -3rem 0 0 -4.3rem
    font-size: 14px
    font-weight: bold

  #percentualParticipacao
    margin: 0 0 0 -4.3rem
    color: #4CAF50
    font-size: 22px
    font-weight: bold

  #linkDetalheMelhoresClientes
    color: black

  #filtrosOpcoesClientesRFV
    color: black

  #filtrosOpcoesClientesExtrato
    color: black

  #filtrosOpcoesClientesABC
    color: black

  #iconCliente
    font-size: 48px

  .container
    max-width: 100%

  #melhoresProdutores
    margin: -0.8rem 0 0 0rem

  #iconInformationMelhoresProdutores
    margin: -1.5rem 0 0 0

  #legendaDistribuicaoCliente
    margin: 1.5rem 0 0 0
    font-size: 11px

  #myChart34
    margin: -3rem 0 0 0

  #melhoresprodutores-form
    background-color: #FFFFF !important

  .titlecard
    font-size: 5px !important
    font-weight: bold !important

  @media screen and (min-width: 481px) and (max-width: 960px) and (-webkit-min-device-pixel-ratio: 1)
  .this
    padding-right: 0rem !important
  #comparativoCad
    margin: -2rem 0 0 -2.1rem
</style>
